import http from "./Http";

const get = async (params) => {
    return http.get(`/order-email-log`, { params });
};

const OrderEmailLogService = {
    get
};

export default OrderEmailLogService;
